import { Avatar } from '@/components/ui';
import WidgetRenderer from './WidgetRenderer';
import type { Page } from '@/types';

interface ProfilePreviewProps {
  page: Page;
}

const ProfilePreview = ({ page }: ProfilePreviewProps) => {
  const sortedWidgets = [...(page.widgets || [])].sort((a, b) => a.order - b.order);

  return (
    <div className="relative">
      {/* Phone Frame */}
      <div className="w-[320px] h-[640px] bg-dark-800 rounded-[40px] p-3 shadow-elevated mx-auto">
        {/* Notch */}
        <div className="absolute top-4 left-1/2 -translate-x-1/2 w-20 h-6 bg-dark-800 rounded-full z-10" />

        {/* Screen */}
        <div
          className="w-full h-full rounded-[32px] overflow-hidden overflow-y-auto scrollbar-hide bg-gray-100 dark:bg-dark-900"
        >
          <div className="p-6 pt-12">
            {/* Profile Header */}
            <div className="text-center mb-8">
              <Avatar
                src={page.avatarUrl || undefined}
                name={page.title}
                size="xl"
                className="mx-auto mb-4"
              />
              <h1 className="text-xl font-bold text-dark-800 dark:text-white mb-2">
                {page.title}
              </h1>
              {page.bio && (
                <p className="text-sm text-dark-800/70 dark:text-gray-400">
                  {page.bio}
                </p>
              )}
            </div>

            {/* Widgets */}
            <div className="space-y-4">
              {sortedWidgets.map((widget) => (
                <WidgetRenderer key={widget.id} widget={widget} preview userId={page.userId} />
              ))}

              {sortedWidgets.length === 0 && (
                <div className="text-center py-8 opacity-50">
                  <p className="text-sm text-dark-800 dark:text-gray-400">
                    No widgets yet
                  </p>
                </div>
              )}
            </div>

            {/* Powered by */}
            <div className="text-center mt-8 pb-4">
              <p className="text-xs text-dark-800/40 dark:text-gray-500">
                Powered by Klipr
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePreview;
